import { GLOBAL_QUERY_KEYS } from "../../../shared/api/globalQueryKeys";

const generalKeys = GLOBAL_QUERY_KEYS.ADMIN.MANAGER.SENTINEL;

const apiKeys = {
  farms: {
    all: (search: string) => [...generalKeys, search],
  },
  farmUsers: {
    all: (farmId: string) => [...generalKeys, farmId],
  },
};

export { apiKeys };
